<template>
  <form @submit.prevent="save">
    <div class="flex flex-row w-full">
      <div class="flex flex-col w-full">
        <div class="flex flex-row">
          <div class="w-1/5 mr-2">
            <label class="text-sm text-grey-700 mb-2"> {{ $t('frontend_type') }} </label>
            <div class="mt-1">
              <select
                v-model="record.type"
                class="
                  h-10
                  outline-none
                  rounded-lg
                  border
                  px-2
                  border-grey-200
                  w-full
                "
                :value="record.type"
                placeholder="Type"
              >
                <option
                  v-for="(type, index) in types"
                  :key="index"
                  :value="type"
                >
                  {{ type }}
                </option>
              </select>
            </div>
          </div>
          <div class="w-1/5 mr-2">
            <label class="text-sm text-grey-700 mb-2"> {{ $t('frontend_name') }} </label>
            <text-input
              v-model="record.name"
              class="mt-1"
              value="record.name"
              :placeholder="$t('frontend_type')"
            />
          </div>
          <div class="w-1/5 mr-2">
            <label class="text-sm text-grey-700 mb-2"> {{ $t('frontend_content') }} </label>
            <text-input
              v-model="record.content"
              class="mt-1"
              value="record.content"
              :placeholder="$t('frontend_content')"
            />
          </div>
          <div class="w-1/5 mr-2">
            <label class="text-sm text-grey-700 mb-2"> TTL </label>
            <text-input
              v-model="record.ttl"
              class="mt-1"
              value="record.ttl"
              placeholder="TTL"
            />
          </div>
          <div
            class="w-1/5 mr-2"
            v-if="record.type == 'MX' || record.type == 'SRV'"
          >
            <label class="text-sm text-grey-700 mb-2"> {{ $t('frontend_priority') }} </label>
            <text-input
              v-model="record.priority"
              class="mt-1"
              value="record.priority"
              :placeholder="$t('frontend_priority')"
            />
          </div>
        </div>

        <div class="flex flex-row mt-4" v-if="record.type == 'SRV'">
          <div class="w-1/4 mr-2">
            <label class="text-sm text-grey-700 mb-2"> {{ $t('frontend_service') }} </label>
            <text-input
              v-model="record.service"
              class="mt-1"
              value="record.service"
              :placeholder="$t('frontend_service')"
            />
          </div>
          <div class="w-1/4 mr-2">
            <label class="text-sm text-grey-700 mb-2"> {{ $t('frontend_protocol') }} </label>
            <div class="mt-1">
              <select
                v-model="record.protocol"
                class="
                  h-10
                  outline-none
                  rounded-lg
                  border
                  px-2
                  border-grey-200
                  w-full
                "
                :value="record.protocol"
                placeholder="Protocol"
              >
                <option value="_tcp">TCP</option>
                <option value="_udp">UDP</option>
                <option value="_tls">TLS</option>
              </select>
            </div>
          </div>
          <div class="w-1/4 mr-2">
            <label class="text-sm text-grey-700 mb-2"> {{ $t('frontend_weight') }} </label>
            <text-input
              v-model="record.weight"
              class="mt-1"
              value="record.weight"
              :placeholder="$t('frontend_weight')"
            />
          </div>
          <div class="w-1/4 mr-2">
            <label class="text-sm text-grey-700 mb-2"> {{ $t('frontend_port') }} </label>
            <text-input
              v-model="record.port"
              class="mt-1"
              value="record.port"
              :placeholder="$t('frontend_port')"
            />
          </div>
        </div>

        <div
          class="flex flex-row mt-4"
          v-if="['A', 'AAA', 'CNAME'].includes(record.type)"
        >
          <gd-checkbox
            v-model="record.proxied"
            label="Enable Cloudflare Proxy"
            labelClass="text-grey-700 ml-2"
          />
        </div>

        <div class="flex flex-row mt-4 justify-end">
          <gd-button :loading="saving" class="mr-3" variant="primary" type="submit"
            >{{ $t('frontend_save') }}</gd-button
          >
          <gd-button :disabled="saving" @click="cancel" type="button"
            >{{ $t('frontend_cancel') }}</gd-button
          >
        </div>
      </div>
      <div class="flex flex-row justify-end mt-2"></div>
    </div>
  </form>
</template>

<script>
import GdButton from './Button';
import GdCheckbox from './Checkbox';
import GdDropdown from './Dropdown';
import GdTabs from './Tabs';
import TextInput from './TextInput';
import GdToggle from './Toggle';

export default {
  name: 'AccountDomainRecordEditor',
  components: {
    GdToggle,
    GdButton,
    GdTabs,
    TextInput,
    GdDropdown,
    GdCheckbox,
  },
  props: {
    current: {
      type: Object,
      default: () => ({
        type: 'A',
        name: '',
        content: '',
        ttl: 3600,
        priority: 0,
        proxied: false,
        service: '',
        protocol: '_tcp',
        weight: 0,
        port: 0,
      }),
    },
    saving: Boolean,
  },
  data() {
    return {
      types: [
        'A',
        'AAAA',
        // 'CAA',
        // 'CERT',
        'CNAME',
        // 'DNSKEY',
        // 'DS',
        // 'HTTPS',
        // 'LOC',
        'MX',
        // 'NAPTR',
        'NS',
        // 'PTR',
        // 'SMIMEA',
        'SPF',
        'SRV',
        // 'SSHFP',
        // 'SVCB',
        // 'TLSA',
        'TXT',
        // 'URI'
      ],
      record: { ...this.current },
    };
  },
  methods: {
    save() {
      this.record.ttl = this.record.proxied ? 1 : this.record.ttl;
      this.record.proxied = ['A', 'AAA', 'CNAME'].includes(this.record.type)
        ? this.record.proxied
        : 0;
      this.$emit('save', this.record);
    },
    cancel() {
      this.$emit('cancel');
    },
  },
};
</script>
